import SignRegionOpenEvent from "../../../../src/events/2022/04/sign-region-open/main";
import * as React from 'react';
export default {
  SignRegionOpenEvent,
  React
};